<template>
  <div class="qr-code-wrapper">
    <el-form
      v-loading="loading"
      :model="params"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="code-ruleForm"
    >
      <el-form-item label="小程序地址" prop="page">
        <el-input v-model.trim="params.page" clearable placeholder="pages/xxxx/xxxx"></el-input>
      </el-form-item>
      <el-form-item label="传入的参数" prop="scene">
        <el-input v-model.trim="params.scene" clearable placeholder="xx&xx&xxx,空参数可以传null"></el-input>
      </el-form-item>
      <el-form-item label="是否透明底" prop="is_hyaline">
        <el-radio-group v-model="params.is_hyaline">
          <el-radio :label="true">透明底</el-radio>
          <el-radio :label="false">非透明底</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="宽度" prop="width">
        <el-input
          v-model.trim="params.width"
          type="number"
          clearable
          placeholder="480 360 720 1280"
        ></el-input>
      </el-form-item>
      <el-form-item label="小程序码" prop="width" v-if="codeUrl !== ''">
        <el-image
          style="width: 150px; height: 150px"
          :src="codeUrl"
          :preview-src-list="[codeUrl]"
          :title="鼠标右键可以保存图片"
        ></el-image>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="onSubmit">立即生成</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      params: {
        is_hyaline: false,
        page: "",
        scene: "null",
        width: ""
      },
      codeUrl: "",
      rules: {
        page: [
          { required: true, message: "请输入小程序页面地址", trigger: "blur" }
        ],
        scene: [
          {
            required: true,
            message: "请输入小程序参数，空值可以传null",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    onSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$api
            .post(`/wechat/miniapp/qr_code_url`, this.params)
            .then(res => {
              if (res.status === 200 || res.status === 201) {
                this.loading = false;
                console.log("地址", res);
                this.codeUrl = res.data;
                // this.ininFrom();
                this.$emit("onSuccess");
                this.$message.success("生成成功");
              }
            })
            .catch(err => {
              this.loading = false;
              console.error("生成失败", err.response);
              this.$notify.error({
                title: "新增失败",
                position: "bottom-right",
                duration: 1500,
                dangerouslyUseHTMLString: true,
                message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    ininFrom() {
      this.params = {
        is_hyaline: false,
        page: "",
        scene: "null",
        width: ""
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.qr-code-wrapper {
  width: 100%;
  .code-ruleForm {
    box-sizing: border-box;
    width: 600px;
    margin: 20px auto;
    padding: 15px 0;
  }
}
</style>